import { BiSearch } from 'react-icons/bi'
import type { FC } from 'react'
import { GrandIconButton, type GrandIconButtonProps } from 'ui'
import { Icon } from '@chakra-ui/react'
import { type WithOptional } from 'ecosystem'

// is used for desktop view to open SearchDesktopSlideOut

interface SearchButtonProps extends WithOptional<GrandIconButtonProps, 'aria-label'> {
  onSearch: () => void
}

export const SearchButton: FC<SearchButtonProps> = ({ onSearch, ...props }) => {
  return (
    <GrandIconButton
      className="SearchButton"
      alignItems="center"
      aria-label="search"
      bg="none"
      color="text.light"
      fontSize="2xl"
      icon={
        <Icon
          as={BiSearch}
          color="var(--chakra-colors-component-TopNavContent-SearchButton-color, var(--chakra-colors-text-default))"
        />
      }
      justifyContent="center"
      onClick={onSearch}
      shadow="none"
      size="sm"
      {...props}
    />
  )
}
